export enum BufferItemType {
    estimateRow,
    costRow
}


// WEBPACK FOOTER //
// ./ClientApp/services/buffer/bufferItemType.ts